<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      height="300"
      width="300"
      class="challenge-card"
      :class="{ 'on-hover': hover }"
      style="word-break: break-all;"
      dark
      elevation="0"
    >
      <v-img
        :class="{ 'on-hover': hover }"
        :contain="true"
        :src="getImageFromChallengeUUID()"
        class="challenge-card-image"
        gradient="to top right, rgba(0,0,0,0), rgba(0,0,0,0.9)">
      </v-img>
      <v-row class="challenge-card-icon">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              x-large
              v-bind="attrs"
              v-on="on"
              :ripple="false"
            >
              <v-icon dark x-large>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list
            :tile="false"
            nav
          >
            <DarkListItem v-for="option in options" :key="option.text">
              <v-btn
                text
                class="ma-0 pa-0"
                :ripple="false"
                :disabled="!option.anyoneCanAccess && !challenge.canModify"
                @click="$emit('action', {id: option.id, challenge: challenge})"
              >
                {{ option.text }}
              </v-btn>
            </DarkListItem>
          </v-list>
        </v-menu>
      </v-row>
      <v-row justify="center" align="center" class="challenge-card-text">
        {{ challenge.name }}
      </v-row>
      <v-row justify="center" align="center" class="activate-challenge-button-container">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            tile
            class="activate-challenge-button"
            :class="{ 'on-hover': hover }"
            @click.native="handleChallengeActivate"
            color="rgb(255, 149, 24)"
            :disabled="isActive"
            >
            <div v-if="isActive">
              Challenge Already Active
            </div>
            <div v-else>
              Go to Challenge
            </div>
          </v-btn>
        </v-hover>
      </v-row>
    </v-card>
  </v-hover>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DarkListItem from '@/components/core/AppBar/utils/DarkListItem'

export default {
  name: 'ChallengeCard',

  components: {
    DarkListItem
  },

  props: ['challenge', 'archived', 'options'],
  data: () => ({
    clickedActivateChallengeButton: false
    // image: require('@/assets/example_challenge_images/_Kzn1lLYSqQ.jpg')
  }),

  methods: {
    ...mapActions(['requestActivateChallenge']),

    async handleChallengeActivate () {
      // this.clickedActivateChallengeButton = true
      // await this.requestActivateChallenge(this.challenge.uuid)
      this.$router.push(`/whiteboard/${this.challenge.uuid}`)
      // this.clickedActivateChallengeButton = false
    },

    getImageFromChallengeUUID () {
      const uuidLastDigit = this.challenge.uuid[this.challenge.uuid.length - 1]
      const uuidLastDigitString = parseInt('0x' + uuidLastDigit).toString()

      const imageNumber = uuidLastDigitString.padStart(2, '0')

      return require('@/assets/example_challenge_images/' + imageNumber + '.jpg')
    }
  },

  computed: {
    ...mapState(['auth']),
    isActive () {
      return this.challenge.uuid === this.auth.userInfo.activeChallenge
    }
  }
}
</script>

<style lang="sass" scoped>
  .challenge-card
    margin: 10px
    cursor: pointer
    transition: all .1s ease-in-out

  .challenge-card:not(.on-hover)
    opacity: 0.9

  .challenge-card-image
    filter: blur(0px)

  .challenge-card-image:not(.on-hover)
    filter: blur(5px)

  .challenge-card-icon
    position: absolute
    right: 20px
    top: 15px

  .challenge-card-text
    position: absolute
    margin-left: auto
    margin-right: auto
    left: 0
    right: 0
    text-align: center
    top: 50%
    transform: translateY(-50%)

  .activate-challenge-button-container
    position: absolute
    margin-left: auto
    margin-right: auto
    right: 0
    top: 100%
    transform: translateY(-100%)
    width: 100%

  .activate-challenge-button
    width: 100%
    transition: background-image 1s ease-in-out
    border-radius: 0 0 4px 4px

  .activate-challenge-button.on-hover
    background-image: linear-gradient(to right, rgb(255, 149, 24), rgb(255, 100, 100))

</style>
